module.exports = __webpack_public_path__ + "static/media/rightArrowWhite.8ec91c41.svg";